export default "__VITE_ASSET__C49Bry3M__"